module.exports = __webpack_public_path__ + "img/partner4.14d49669.jpg";